import { useContext } from 'react';
import { MessagesContext } from './context';

export const useMessage = () => useContext(MessagesContext);
